import { Feature, FeatureTypes, FeaturesAction, initialState } from '../types';
import { Reducer } from 'redux';

const getFeatures: Reducer<Feature[], FeaturesAction> = (
  state: Feature[] = initialState.features,
  action: FeaturesAction,
): Feature[] => {
  switch (action.type) {
    case FeatureTypes.FETCH_ALL:
      return action.payload;
    default:
      return state;
  }
};

export default getFeatures;
